export default __webpack_public_path__ + "static/media/cloak.10214261.svg";